import React, { memo } from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import TreatmentProvidersMegaMenu from './TreatmentProvidersMegaMenu'
import HiddenSSR from '../../atoms/HiddenSSR/HiddenSSR'
import { ChevronRight } from 'react-bootstrap-icons'

const Style = styled.div`
  justify-content: center;
  width: 100vw;
  min-height: 600px;
  display: flex;
  background: #f6f8f9;
  position: absolute;
  top: 70px;
  left: 0;
  z-index: 301;
  .left-sidebar {
    height: inherit;
    display: flex;
    flex-direction: column;
    min-width: 260px;
    height: inherit;
    background: #f6f8f9;
    padding: 40px 0px 16px 0px;
  }
  .container {
    padding: 24px 24px 24px 34px;
    display: flex;
    background: white;
    width: 100%;
    min-height: 600px;
  }

  .header {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #4d657f;
    padding-left: 16px;
  }
`

const BoldedText = styled.span`
  font-weight: 700;
`
const linksNav = [
  {
    name: 'About Us',
    header: 'About Us',
    text: 'Recovery.com combines independent research with expert guidance on addiction and mental health treatment. Our mission is to help everyone find the best path to recovery through the most comprehensive, helpful network of treatment providers worldwide.',
    button: 'About Recovery.com',
    link: '/about/'
  },
  {
    name: 'For Treatment Providers',
    header: 'It’s Free to Be on Recovery.com',
    text: 'Every month, 150,000 people search for addiction or mental health treatment on Recovery.com. Let us help them find you. ',
    button: 'Claim Your Profile Today',
    link: 'https://providers.recovery.com'
  },
  {
    name: 'Our Criteria',
    header: 'Our Criteria',
    text: 'We list any treatment center that meets our rehab criteria, giving you the best list of options possible when looking for treatment.',
    button: 'Our Criteria',
    link: '/criteria/',
    header2: 'Claimed and Verify Process',
    text2: (
      <>
        Recovery.com uses a standard procedure to make sure treatment provider
        profiles on our site are current and complete. We do this by{' '}
        <BoldedText>claiming</BoldedText> or <BoldedText>verifying</BoldedText>{' '}
        profiles.
      </>
    ),
    button2: 'Learn More',
    link2: '/claim-verify-process/'
  },
  {
    name: 'Careers',
    header: 'Careers',
    text: 'Join our global mission of connecting patients with addiction and mental health treatment. See open positions and help people step into hope.',
    button: 'Careers',
    link: '/careers/'
  },
  {
    name: 'Contact Us',
    header: 'Contact Us',
    link: '/contact/',
    subheader1: 'For Providers',
    subheader2: 'For Treatment Seekers',
    text1:
      'If you’re a treatment provider and have a question, please reach out and someone from our Customer Success team will be in touch with you shortly.',
    button: 'Contact Us',
    header2: 'For Treatment Seekers',
    text2:
      "If you're looking for treatment, please browse the site to reach out to treatment centers directly."
  }
]
export const Link = ({ selected, setSelected, linkData }) => {
  return (
    <React.Fragment>
      <div
        className={`flex h-14 w-full cursor-pointer items-center justify-between px-4 ${
          selected === linkData.name
            ? 'bg-white font-semibold text-gray-1100'
            : ''
        }`}
        onClick={() => {
          setSelected(linkData.name)
        }}
        onMouseEnter={() => {
          setSelected(linkData.name)
        }}
      >
        {linkData.name}
        <ChevronRight className="ml-4 h-4 w-3" />
      </div>
    </React.Fragment>
  )
}

const AboutPanel = ({ onMouseLeave, ...rest }) => {
  const [selected, setSelected] = useState('About Us')
  return (
    <Style
      {...rest}
      className="rounded-b-2xl shadow-lg"
    >
      <div className="flex w-inherit max-w-[1600px]">
        <div className="left-sidebar">
          <div style={{ height: '40px', width: '100%' }}>
            <p className="header">Learn</p>
          </div>
          <div>
            {linksNav.map((link) => (
              <Link
                selected={selected}
                linkData={link}
                setSelected={setSelected}
                className="hover:!text-gray-1100"
                key={link.name}
              />
            ))}
          </div>
        </div>
        <div className="container">
          <HiddenSSR visible={selected === 'About Us'}>
            <TreatmentProvidersMegaMenu
              linkData={linksNav.filter((nav) => nav.name === 'About Us')[0]}
            />
          </HiddenSSR>
          <HiddenSSR visible={selected === 'Our Criteria'}>
            <TreatmentProvidersMegaMenu
              linkData={
                linksNav.filter((nav) => nav.name === 'Our Criteria')[0]
              }
            />
          </HiddenSSR>
          <HiddenSSR visible={selected === 'For Treatment Providers'}>
            <TreatmentProvidersMegaMenu
              linkData={
                linksNav.filter(
                  (nav) => nav.name === 'For Treatment Providers'
                )[0]
              }
            />
          </HiddenSSR>
          <HiddenSSR visible={selected === 'Careers'}>
            <TreatmentProvidersMegaMenu
              linkData={linksNav.filter((nav) => nav.name === 'Careers')[0]}
            />
          </HiddenSSR>
          <HiddenSSR visible={selected === 'Contact Us'}>
            <TreatmentProvidersMegaMenu
              linkData={linksNav.filter((nav) => nav.name === 'Contact Us')[0]}
            />
          </HiddenSSR>
        </div>
      </div>
    </Style>
  )
}

export default memo(AboutPanel)
